import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';

export const ReactionsContentFragment_content: GraphQLTaggedNode = graphql`
	fragment ReactionsContentFragment_content on Content {
		id
		contentReactionsSummary {
			reactionsCount
			ari
			containerAri
			reactionsSummaryForEmoji {
				emojiId
				count
				reacted
				id
			}
		}
	}
`;
